import { CardProps } from '@rhg/components/card';
import { Box, SxProps, Theme } from '@rhg/libs/material';
import { sxAppend } from '@rhg/libs/material/sx';
import { AriaRole, forwardRef } from 'react';
import { BANNER_HEIGHT, BANNER_WIDTH } from './types';

const styleContainer = {
    width: BANNER_WIDTH,
    height: BANNER_HEIGHT,
    display: 'flex',
};

const styleBannerImageContainer = {
    width: '100%',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
};

// Scales image to 3/2 aspect ratio
const styleBannerImage = {
    width: '100%',
    backgroundSize: 'cover',
    backgroundPositionX: 'center',
    backgroundPositionY: 'center',
    height: '100%',
    aspectRatio: `${3 / 2}`,
    position: 'relative',
};

interface ProgramBannerProps {
    programImageSrc?: CardProps['imageSrc'];
    sx?: SxProps<Theme>;
    sxBannerImage?: SxProps<Theme>;
    sxBannerImageContainer?: SxProps<Theme>;
    role?: AriaRole;
}
export const ProgramBannerImage = forwardRef(function BannerImageNoRef(
    {
        programImageSrc,
        sx,
        sxBannerImage,
        sxBannerImageContainer,
        role = 'img',
    }: ProgramBannerProps,
    ref
) {
    return (
        <Box ref={ref} sx={sxAppend(styleContainer, sx)}>
            <Box
                sx={sxAppend(styleBannerImageContainer, sxBannerImageContainer)}
            >
                <Box
                    role={role}
                    sx={sxAppend(
                        styleBannerImage,
                        sxBannerImage,
                        programImageSrc && {
                            backgroundImage: `url(${programImageSrc})`,
                        }
                    )}
                    {...(role === 'img' ? { alt: '' } : {})}
                />
            </Box>
        </Box>
    );
});
